/* Copyright Verge Technologies 2018
 * @file services.js
 * @author Brenton Watt <brenton@verge.co.za>
 */


// Modules
import React from 'react';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { CONTENT_QUERY } from '../../graphql';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';

const Services = (props) => {
  window.scrollTo(0, 0);
  return (
    <div>
      <Header crumbs={props.crumbs} />
      <div className="page-heading heading-service">Services & Support</div>

      <Query query={CONTENT_QUERY} fetchPolicy="cache-and-network" variables={{ slug: "services_support" }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
                        <div className="content-list-container icon-list">
                            <ul>
                              <li className="services-card" style={{ height: 'auto' }}>
                                <div className="icon-block" style={{ height: '100%' }}>
                                  <div className="icon">
                                    <svg
                                      width="71px"
                                      height="63px"
                                      viewBox="0 0 71 63"
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <g transform="translate(1.000000, 1.000000)" stroke="#004DA9" strokeWidth="3">
                                          <path
                                            d="M64.828,36.537 L67.811,35.471 L65.821,29.927 L62.836,31.064 C61.5474382,28.7863295 59.7466356,26.8396824 57.576,25.378 L58.927,22.464 L53.596,19.976 L52.245,22.89 C49.7256906,22.1670319 47.0718654,22.0454382 44.497,22.535 L43.433,19.549 L37.889,21.539 L38.955,24.524 C36.6773295,25.8125618 34.7306824,27.6133644 33.269,29.784 L30.355,28.433 L27.867,33.764 L30.781,35.115 C30.0580319,37.6343094 29.9364382,40.2881346 30.426,42.863 L27.511,43.929 L29.501,49.473 L32.486,48.407 C33.7745618,50.6846705 35.5753644,52.6313176 37.746,54.093 L36.395,57.007 L41.726,59.495 L43.077,56.581 C45.5963094,57.3039681 48.2501346,57.4255618 50.825,56.936 L51.891,59.921 L57.435,57.931 L56.369,54.949 C58.6466705,53.6604382 60.5933176,51.8596356 62.055,49.689 L64.969,51.04 L67.457,45.709 L64.543,44.358 C65.2077056,41.8030506 65.3049831,39.1335529 64.828,36.537 Z M51.181,49.332 C45.8617007,51.2751704 39.9743042,48.5382891 38.0311149,43.2189967 C36.0879257,37.8997043 38.8247861,32.0122981 44.1440716,30.06909 C49.4633571,28.1258819 55.350773,30.8627214 57.294,36.182 C59.222973,41.5007174 56.4906821,47.3782939 51.181,49.332 Z"
                                            id="Path_331"
                                          />
                                          <path
                                            d="M27.654,22.393 L29.929,23.175 L31.421,18.91 L29.146,18.128 C29.4940531,16.1608253 29.3724158,14.139249 28.791,12.228 L30.991,11.162 L29.075,7.11 L26.801,8.248 C25.6341001,6.62092731 24.1311711,5.26361906 22.394,4.268 L23.176,1.993 L18.982,0.5 L18.201,2.775 C16.2338253,2.42694694 14.212249,2.54858416 12.301,3.13 L11.235,0.93 L7.183,2.846 L8.249,5.046 C6.62192731,6.21289986 5.26461906,7.71582887 4.269,9.453 L1.994,8.671 L0.501,12.939 L2.776,13.721 C2.42794694,15.6881747 2.54958416,17.709751 3.131,19.621 L0.931,20.687 L2.85,24.739 L5.05,23.673 C6.21689986,25.3000727 7.71982887,26.6573809 9.457,27.653 L8.675,29.928 L12.94,31.421 L13.722,29.146 C15.6891747,29.4940531 17.710751,29.3724158 19.622,28.791 L20.688,30.991 L24.74,29.072 L23.673,26.8 C25.3004142,25.6331853 26.6580661,24.1302534 27.654,22.393 Z M23.318,18.555 C21.8834005,22.615969 17.4288812,24.745625 13.3674872,23.3122292 C9.30609317,21.8788335 7.17511696,17.4249455 8.60730892,13.3631269 C10.0395009,9.30130819 14.492757,7.16901198 18.555,8.6 C22.6121515,10.0410576 24.7412462,14.490566 23.318,18.554 L23.318,18.555 Z"
                                            id="Path_332"
                                          />
                                        </g>
                                      </g>
                                    </svg>
                                  </div>
                                  <h5>Services</h5>
                                </div>
                                <div className="content-block">
                                  <h2>The Separations Service Department offers servicing and maintenance on the following products:</h2>
                                  <p>
                                    Hamilton Robotics instruments
                                    <br />
                                    AB Sciex instruments
                                    <br />
                                    Molecular Devices instruments
                                    <br />
                                    Sotax dissolution systems and Pharmatron physical testing equipment
                                    <br />
                                    Nüve equipment
                                    <br />
                                    Evoqua water systems
                                    <br />
                                    Radleys equipment
                                    <br />
                                    Macherey-Nagel photometers
                                    <br />
                                    All makes of pipettes
                                  </p>
                                </div>
                                <div className="control">
                                <Link to="/services_support/services" className="button button-green">
                                  View more
                                </Link>
                                </div>
                              </li>
                              <li className="services-card" style={{ height: 'auto' }}>
                                <div className="icon-block" style={{ height: '100%' }}>
                                  <div className="icon">
                                    <svg
                                      width="71px"
                                      height="63px"
                                      viewBox="0 0 71 63"
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <g transform="translate(1.000000, 1.000000)" stroke="#004DA9" strokeWidth="3">
                                          <path
                                            d="M64.828,36.537 L67.811,35.471 L65.821,29.927 L62.836,31.064 C61.5474382,28.7863295 59.7466356,26.8396824 57.576,25.378 L58.927,22.464 L53.596,19.976 L52.245,22.89 C49.7256906,22.1670319 47.0718654,22.0454382 44.497,22.535 L43.433,19.549 L37.889,21.539 L38.955,24.524 C36.6773295,25.8125618 34.7306824,27.6133644 33.269,29.784 L30.355,28.433 L27.867,33.764 L30.781,35.115 C30.0580319,37.6343094 29.9364382,40.2881346 30.426,42.863 L27.511,43.929 L29.501,49.473 L32.486,48.407 C33.7745618,50.6846705 35.5753644,52.6313176 37.746,54.093 L36.395,57.007 L41.726,59.495 L43.077,56.581 C45.5963094,57.3039681 48.2501346,57.4255618 50.825,56.936 L51.891,59.921 L57.435,57.931 L56.369,54.949 C58.6466705,53.6604382 60.5933176,51.8596356 62.055,49.689 L64.969,51.04 L67.457,45.709 L64.543,44.358 C65.2077056,41.8030506 65.3049831,39.1335529 64.828,36.537 Z M51.181,49.332 C45.8617007,51.2751704 39.9743042,48.5382891 38.0311149,43.2189967 C36.0879257,37.8997043 38.8247861,32.0122981 44.1440716,30.06909 C49.4633571,28.1258819 55.350773,30.8627214 57.294,36.182 C59.222973,41.5007174 56.4906821,47.3782939 51.181,49.332 Z"
                                            id="Path_331"
                                          />
                                          <path
                                            d="M27.654,22.393 L29.929,23.175 L31.421,18.91 L29.146,18.128 C29.4940531,16.1608253 29.3724158,14.139249 28.791,12.228 L30.991,11.162 L29.075,7.11 L26.801,8.248 C25.6341001,6.62092731 24.1311711,5.26361906 22.394,4.268 L23.176,1.993 L18.982,0.5 L18.201,2.775 C16.2338253,2.42694694 14.212249,2.54858416 12.301,3.13 L11.235,0.93 L7.183,2.846 L8.249,5.046 C6.62192731,6.21289986 5.26461906,7.71582887 4.269,9.453 L1.994,8.671 L0.501,12.939 L2.776,13.721 C2.42794694,15.6881747 2.54958416,17.709751 3.131,19.621 L0.931,20.687 L2.85,24.739 L5.05,23.673 C6.21689986,25.3000727 7.71982887,26.6573809 9.457,27.653 L8.675,29.928 L12.94,31.421 L13.722,29.146 C15.6891747,29.4940531 17.710751,29.3724158 19.622,28.791 L20.688,30.991 L24.74,29.072 L23.673,26.8 C25.3004142,25.6331853 26.6580661,24.1302534 27.654,22.393 Z M23.318,18.555 C21.8834005,22.615969 17.4288812,24.745625 13.3674872,23.3122292 C9.30609317,21.8788335 7.17511696,17.4249455 8.60730892,13.3631269 C10.0395009,9.30130819 14.492757,7.16901198 18.555,8.6 C22.6121515,10.0410576 24.7412462,14.490566 23.318,18.554 L23.318,18.555 Z"
                                            id="Path_332"
                                          />
                                        </g>
                                      </g>
                                    </svg>
                                  </div>
                                  <h5>Workflows</h5>
                                </div>
                                <div className="content-block">
                                  <h2>The Separations Applications Department offers specialised support for the following instrumentation:</h2>
                                  <p>
                                    Hamilton Robotics
                                    <br />
                                    Molecular Devices
                                    <br />
                                    AB Sciex
                                    <br />
                                    Applications Specialists guide and assist customers with their instruments from
                                    installation and setup, through to software programming and troubleshooting.
                                  </p>
                                  <p>Application support can be incorporated into customisable service plans.</p>
                                </div>
                                <div className="control">
                                <Link to="/services_support/applications" className="button button-green">
                                  View more
                                </Link>
                                </div>
                              </li>
                            </ul>
                          </div>

            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div>
<div dangerouslySetInnerHTML={{__html: data.getContent.body}} />
            </div>
          );
        }}
      </Query>
  
      <Footer />
    </div>
  );
};

export default Services;



// WEBPACK FOOTER //
// ./src/pages/services/services.page.js